<template>
  <b-modal centered size="lg" id="editBoard" hide-header hide-footer>
    <BoardForm :parentBoard="parentBoard"/>
  </b-modal>
</template>

<script>
import BoardForm from './BoardForm'
export default {
  name: 'EditBoard',
  components: {
    BoardForm
  },
  props: {
    parentBoard: Object
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditBoard.vue